const component = require('../component/component');

const date_interval = Object.assign({}, component, {
    subelements: {
        start: null,
        end: null
    },
    minDate: false,
    maxDate: false,
    startOfTheWeek: 1,
    format: 'yyyy-MM-dd',
    locale: 'en',
    time: false,
    tempusDominusStartObj: false,
    tempusDominusEndObj: false,

    init: function () {
        component.init.call(this);

        let disabledDates = [];

        if (this.minDate !== false) {
            disabledDates.push(this.minDate);
        }

        if (this.maxDate !== false) {
            disabledDates.push(this.maxDate);
        }

        let initParams = {
            useCurrent: false,
            display: {
                components: {
                    calendar: true,
                    date: true,
                    month: true,
                    year: true,
                    decades: true,
                    clock: this.time,
                    hours: this.time,
                    minutes: this.time,
                    seconds: false,
                    useTwentyfourHour: undefined
                },
                buttons: {
                    today: true,
                    clear: true,
                    close: true
                },
            },
            localization: {
                startOfTheWeek: this.startOfTheWeek,
                format: this.format,
                locale: this.locale
            },
            restrictions: {
                minDate: this.minDate === false ? undefined : this.minDate,
                maxDate: this.maxDate === false ? undefined : this.maxDate,
                disabledDates: disabledDates,
                enabledDates: [],
                daysOfWeekDisabled: [],
                disabledTimeIntervals: [],
                disabledHours: [],
                enabledHours: []
            }
        };

        this.tempusDominusStartObj = new tempusDominus.TempusDominus(this.subelements.start, initParams);
        this.tempusDominusEndObj = new tempusDominus.TempusDominus(this.subelements.end, initParams);

        //using event listeners
        this.subelements.start.addEventListener('change', (e) => {
            this.tempusDominusEndObj.updateOptions({
                restrictions: {
                    minDate: e.detail.date,
                },
            });
        });

        this.subelements.end.addEventListener('change', (e) => {
            this.tempusDominusStartObj.updateOptions({
                restrictions: {
                    maxDate: e.detail.date,
                },
            });
        });
    },

    getValue: function () {
        if (this.isHidden && this.hiddenValue !== false) {
            return this.hiddenValue;
        }
        
        let value = {};
        if (this.subelements.start !== null) {
            value.start = this.subelements.start.value;
        }
        if (this.subelements.end !== null) {
            value.end = this.subelements.end.value;
        }

        return value;
    },

    formPostData: function (formPostData) {
        if (this.subelements.start !== null) {
            formPostData = this.hm.helper.formPostData(formPostData, this.subelements.start.name, this.subelements.start.value);
        }

        if (this.subelements.end !== null) {
            formPostData = this.hm.helper.formPostData(formPostData, this.subelements.end.name, this.subelements.end.value);
        }

        return formPostData;
    }
});

module.exports = date_interval;